import curry from "./curry";
import eqBy from "./eqBy";
import props from "./props";

// [k] -> {k: v} -> {k: v} -> Boolean
const eqProps = curry((keys, objA, objB) => eqBy(props(keys))(objA, objB));

export default eqProps;
